module.exports = __webpack_public_path__ + "static/media/gina-cunningham.7689f54b.png";